require('./component-tabindex');

module.exports = 'component-tabindex';


/*****************
 ** WEBPACK FOOTER
 ** ./~/component-tabindex/src/index.js
 ** module id = 355
 ** module chunks = 1
 **/